import { object, string, type ObjectSchema, number, boolean } from 'yup';
import { FieldValues } from './types';

export const validationSchema: ObjectSchema<FieldValues> = object({
  price: number().min(0).required(),
  oldPrice: number().min(0).optional(),
  isBestPrice: boolean().required(),
  recoveryTime: string().trim().required(),
  isFreeDiagnostic: boolean().required(),
  isPopular: boolean().required(),
  guarantee: number().min(0).required(),
  serviceInfoId: string().trim().required(),
  slug: string().trim().required(),
  previewTextEn: string().trim().optional(),
  previewTextPl: string().trim().optional(),
  previewTextRu: string().trim().optional(),
  previewTextUk: string().trim().optional(),
}).required();
